import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mapings = new Map<ProfiBazaAPIModels.RODOManualType, string>([
    [ProfiBazaAPIModels.RODOManualType.CRUIP, 'CRUIP'],
	[ProfiBazaAPIModels.RODOManualType.ProposalAccess, 'Wniosek'],
]);

export const map = (value: ProfiBazaAPIModels.RODOManualType): string =>
	mapings.get(value) ?? '';
